import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

const SettingsCard = ({ title = 'Settings', children, actions, sx }) => {
  return (
    <Card sx={sx}>
      <CardHeader
        title={title}
        titleTypographyProps={{ variant: 'titleLarge' }}
        action={actions}
      />
      <Divider sx={{ marginX: 2 }} />
      <CardContent>{children}</CardContent>
    </Card>
  );
};

export default SettingsCard;
